import { z } from "zod";

const PermissionSchema = z.object({
    id: z.number(),
    name: z.string(),
    display_name: z.nullable(z.string()),
    group: z.nullable(z.string()),
    guard_name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    pivot: z.object({
        role_id: z.number(),
        permission_id: z.number(),
    }),
});

const UserSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    email_verified_at: z.nullable(z.string()),
    created_at: z.string(),
    updated_at: z.string(),
    channex_user_api_key: z.nullable(z.string()),
    username: z.nullable(z.string()),
    phone: z.nullable(z.string()),
    pivot: z.object({
        model_type: z.string(),
        role_id: z.number(),
        model_id: z.string(),
    }),
});

export const RoleSchema = z.object({
    id: z.number(),
    name: z.string(),
    property_id: z.nullable(z.string()),
    display_name: z.string(),
    guard_name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    permissions: z.array(PermissionSchema),
    users: z.array(UserSchema),
});

const PaginationSchema = z.object({
    current_page: z.number(),
    from: z.nullable(z.number()),
    to: z.nullable(z.number()),
    total: z.number(),
    per_page: z.number(),
    last_page: z.number(),
    next_page: z.number(),
    prev_page: z.number(),
    path: z.string(),
    next_page_url: z.nullable(z.string()),
    prev_page_url: z.nullable(z.string()),
    first_page_url: z.string(),
    last_page_url: z.string(),
});

export const RolesResponse = z.object({
    code: z.number(),
    message: z.string(),
    success: z.boolean(),
    data: z.array(RoleSchema),
    pagination: PaginationSchema,
});

export type RolesResponseType = z.infer<typeof RolesResponse>;
export type RoleType = z.infer<typeof RoleSchema>;
